// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../static-assets/fonts/sourcesanspro-regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../static-assets/fonts/sourcesanspro-black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../static-assets/fonts/sourcesanspro-blackitalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../static-assets/fonts/sourcesanspro-bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../static-assets/fonts/sourcesanspro-bolditalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../static-assets/fonts/sourcesanspro-extralight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../static-assets/fonts/sourcesanspro-extralightitalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../static-assets/fonts/sourcesanspro-italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../static-assets/fonts/sourcesanspro-light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../static-assets/fonts/sourcesanspro-lightitalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../static-assets/fonts/sourcesanspro-semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../static-assets/fonts/sourcesanspro-semibolditalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Source Sans Pro';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    format('truetype');
}

@font-face {
  font-family: 'Source Sans Pro Black';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
  font-family: 'Source Sans Pro Black Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
    format('truetype');
}

@font-face {
  font-family: 'Source Sans Pro Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}

@font-face {
  font-family: 'Source Sans Pro Bold Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___})
    format('truetype');
}

@font-face {
  font-family: 'Source Sans Pro Extra Light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___})
    format('truetype');
}

@font-face {
  font-family: 'Source Sans Pro Extra Light Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___})
    format('truetype');
}

@font-face {
  font-family: 'Source Sans Pro Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___})
    format('truetype');
}

@font-face {
  font-family: 'Source Sans Pro Light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
}

@font-face {
  font-family: 'Source Sans Pro Light Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___})
    format('truetype');
}

@font-face {
  font-family: 'Source Sans Pro Semibold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___})
    format('truetype');
}

@font-face {
  font-family: 'Source Sans Pro Semibold Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___})
    format('truetype');
}
`, "",{"version":3,"sources":["webpack://./src/utils/fonts.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B;sBACoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,+DAA8E;AAChF;;AAEA;EACE,2CAA2C;EAC3C;sBACoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,+DAA6E;AAC/E;;AAEA;EACE,0CAA0C;EAC1C;sBACoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C;sBACoB;AACtB;;AAEA;EACE,iDAAiD;EACjD;sBACoB;AACtB;;AAEA;EACE,qCAAqC;EACrC;sBACoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,+DAA8E;AAChF;;AAEA;EACE,2CAA2C;EAC3C;sBACoB;AACtB;;AAEA;EACE,uCAAuC;EACvC;sBACoB;AACtB;;AAEA;EACE,8CAA8C;EAC9C;sBACoB;AACtB","sourcesContent":["@font-face {\n  font-family: 'Source Sans Pro';\n  src: url(../../static-assets/fonts/sourcesanspro-regular.ttf)\n    format('truetype');\n}\n\n@font-face {\n  font-family: 'Source Sans Pro Black';\n  src: url(../../static-assets/fonts/sourcesanspro-black.ttf) format('truetype');\n}\n\n@font-face {\n  font-family: 'Source Sans Pro Black Italic';\n  src: url(../../static-assets/fonts/sourcesanspro-blackitalic.ttf)\n    format('truetype');\n}\n\n@font-face {\n  font-family: 'Source Sans Pro Bold';\n  src: url(../../static-assets/fonts/sourcesanspro-bold.ttf) format('truetype');\n}\n\n@font-face {\n  font-family: 'Source Sans Pro Bold Italic';\n  src: url(../../static-assets/fonts/sourcesanspro-bolditalic.ttf)\n    format('truetype');\n}\n\n@font-face {\n  font-family: 'Source Sans Pro Extra Light';\n  src: url(../../static-assets/fonts/sourcesanspro-extralight.ttf)\n    format('truetype');\n}\n\n@font-face {\n  font-family: 'Source Sans Pro Extra Light Italic';\n  src: url(../../static-assets/fonts/sourcesanspro-extralightitalic.ttf)\n    format('truetype');\n}\n\n@font-face {\n  font-family: 'Source Sans Pro Italic';\n  src: url(../../static-assets/fonts/sourcesanspro-italic.ttf)\n    format('truetype');\n}\n\n@font-face {\n  font-family: 'Source Sans Pro Light';\n  src: url(../../static-assets/fonts/sourcesanspro-light.ttf) format('truetype');\n}\n\n@font-face {\n  font-family: 'Source Sans Pro Light Italic';\n  src: url(../../static-assets/fonts/sourcesanspro-lightitalic.ttf)\n    format('truetype');\n}\n\n@font-face {\n  font-family: 'Source Sans Pro Semibold';\n  src: url(../../static-assets/fonts/sourcesanspro-semibold.ttf)\n    format('truetype');\n}\n\n@font-face {\n  font-family: 'Source Sans Pro Semibold Italic';\n  src: url(../../static-assets/fonts/sourcesanspro-semibolditalic.ttf)\n    format('truetype');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
